__turbopack_context__.v({
  "countrySelectorButton": "Step1GranjaForm-module__1IlEja__countrySelectorButton" + " " + "Step1GranjaForm-module__1IlEja__inputField",
  "formWrapper": "Step1GranjaForm-module__1IlEja__formWrapper",
  "highlightMarker": "Step1GranjaForm-module__1IlEja__highlightMarker",
  "inputError": "Step1GranjaForm-module__1IlEja__inputError",
  "inputField": "Step1GranjaForm-module__1IlEja__inputField",
  "stepperContainer": "Step1GranjaForm-module__1IlEja__stepperContainer",
  "stepperNav": "Step1GranjaForm-module__1IlEja__stepperNav",
  "submitBtn": "Step1GranjaForm-module__1IlEja__submitBtn",
});
